const path = require('path')

export default {
  getLangs: (r) => {
    var langs={};
    var _langs= r.keys().map(function(key){
      var lean={};
      var basename = path.basename(key, path.extname(key)).replace("\.","_");
      lean[basename]=r(key);
      return  lean;
    });
    for(var i=0;i<_langs.length;i++){
      langs = Object.assign(langs, _langs[i]);
    }
    return langs;
  }
}



// WEBPACK FOOTER //
// ./src/utils/langs/index.js